export default __webpack_public_path__ + "static/media/vi-flag.4f2b141f.svg";